import { getLineMidPoint } from 'app/agriculture/components/utils/getLineMidPoint';
import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';
import { LineStringGeometry } from 'app/agriculture/queries/types/geometry/LineStringGeometry';
import { PolygonGeometry } from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import polylabel from 'polylabel';
import { MapLocation } from 'app/agriculture/queries/types/MapLocation';

export function convertGeometryToMapLocation({
    type,
    coordinates,
}: PointGeometry | LineStringGeometry | PolygonGeometry): MapLocation {
    switch (type) {
        case 'Point': {
            return { latitude: coordinates[1], longitude: coordinates[0] };
        }
        case 'LineString': {
            const [longitude, latitude] = getLineMidPoint(coordinates) ?? [];
            if (longitude == null || latitude == null)
                throw new Error('invalid LineStringGeometry');
            return { longitude, latitude };
        }
        case 'Polygon': {
            const [longitude, latitude] = polylabel(coordinates);
            if (longitude == null || latitude == null) throw new Error('invalid PolygonGeometry');
            return { longitude, latitude };
        }
    }
}
